import { defaultPlaylistImages } from '@/lib/utils/defaultImages';

export const getRandomDefaultImage = (
  type: 'square' | 'video' = 'square',
): string => {
  void type;
  const selection =
    defaultPlaylistImages[
      Math.floor(Math.random() * defaultPlaylistImages.length)
    ];

  return selection.publicPath;
};
